import * as React from "react";
import styles from "./ContactSection.module.scss";
import { useNavigate } from "react-router-dom";
export default function ContactSection() {
  const navigate = useNavigate();
  return (
    <section className={styles.container} onClick={() => navigate('/support')}>
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/73eff6c282940da2fa2c16ecfd44995a602ecd39b937abd68087fe6886e18a37?placeholderIfAbsent=true&apiKey=a517fac07ef946f8ab57e1424b0111c7"
        className={styles.heroImage}
        alt="Contact section hero image"
      />
      <div className={styles.contentWrapper}>
        <div className={styles.contentInner}>
          <div className={styles.titleContainer}>
            <div className={styles.titleWrapper}>
              <div className={styles.title}>Contact us</div>
            </div>
          </div>
          <p className={styles.description}>
            Step into the future of storytelling with Troak. Discover, play, and
            immerse yourself in millions of interactive stories designed just
            for you. Explore the endless possibilities now!
          </p>
        </div>
      </div>
    </section>
  );
}
